import isArray from '../checkVarType/isArray';

/**
  * @desc compose a DOMElement css className
  *
  * @param {array} clsArray array of strings
  *
  * @returns {string|null} DOMElement css className or null
*/
export default function makeClassName(clsArray) {
  if (!isArray(clsArray)) {
    return null;
  }
  return clsArray.filter(Boolean).join(' ').trim() || null;
}
